<template>
  <v-layout justify-center>
    <v-dialog v-model="open" max-width="600px" persistent>
      <v-card :loading="loading">
        <v-card-text v-if="user">
          <div class="text-center headline">
            <v-avatar color="grey" class="mt-5">
              <v-icon dark>mdi-account</v-icon>
            </v-avatar>
          </div>
          <div class="text-center headline mt-3 black--text">{{user.firstName}} {{user.lastName}}</div>
          <div class="text-center">
            <a :href="`mailto:${user.email}`">{{user.email}}</a>
          </div>
          <div class="text-center mt-3">{{user.program}}</div>
          <div class="text-center">{{user.studyType}}</div>
          <v-alert
            outlined
            type="error"
            prominent
            border="left"
            class="mt-5"
          >En demandant le contact d'urgence de cette personne, vos données seront systématiquement enregistrées et soumises à des contrôles. Toute utilisation abusive de ce service sera dénoncée et sanctionnée par des mesures disciplinaires.</v-alert>
          <v-checkbox
            v-model="consentAccepted"
            label="J'ai pris connaissance et accepte les condititions d'utilisation ci-dessus."
          ></v-checkbox>
          <div v-if="loading" class="my-5">
            <div class="text-center">{{currentMessage}}</div>
          </div>
          <div v-if="!loading && emergencyContact !== null">
            <div v-if="Object.keys(emergencyContact).length">
              <v-simple-table>
                <thead>
                  <tr>
                    <th class="text-left">Nom complet</th>
                    <th class="text-left">Téléphone</th>
                    <th class="text-left">Lien de parenté</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{emergencyContact.fullName}}</td>
                    <td>{{emergencyContact.phoneNumber}}</td>
                    <td>{{emergencyContact.relationship}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
            <div v-else>La personne n'a pas renseigné de contact d'urgence</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            :disabled="loading"
            @click="closeDialog"
          >{{emergencyContact ? 'Fermer' : 'Annuler'}}</v-btn>
          <v-btn
            text
            :disabled="!consentAccepted || loading"
            @click="loadEmergencyContact"
            v-if="!emergencyContact"
          >Contact d'urgence</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  props: ["open", "toggleDialog", "user", "currentUser"],
  data: () => ({
    consentAccepted: false,
    loading: false,
    messages: [
      "Demande en cours de traitement...",
      "Enregistrement de la demande effectuée par ",
      "Récupération des coordonnées la personne..."
    ],
    currentMessage: "",
    index: 0,
    interval: null,
    emergencyContact: null
  }),
  methods: {
    loadEmergencyContact: async function() {
      this.messages[1] = this.messages[1] + this.currentUser.name + "...";
      this.changeMessage();
      this.loading = true;
      this.interval = window.setInterval(() => {
        this.changeMessage();
      }, 1500);
      const { data: emergencyContact } = await axios.get(
        `${process.env.VUE_APP_API_URI}/collaborator/users/${this.user._id}/contacts`
      );
      this.emergencyContact = emergencyContact;
    },
    changeMessage: function() {
      this.currentMessage = this.messages[this.index];
      this.index += 1;
    },
    closeDialog: function() {
      this.toggleDialog();
      this.emergencyContact = null;
      this.consentAccepted = false;
    }
  },
  watch: {
    index: function(value) {
      if (value === 4) {
        this.loading = false;
        this.interval = window.clearInterval(this.interval);
        this.index = 0;
        this.messages[1] = this.messages[1].replace(
          `${this.currentUser.name}...`,
          ""
        );
      }
    }
  }
};
</script>